// Pure shaping only, so the unit suite can import this file.
import type { RatingsPoint } from '@/lib/app-detail/ratings-history';
import type { WorldwidePoint } from '@/lib/app-detail/worldwide-ratings';

/** One point of the merged Ratings card, whichever scope drew it. */
export type ScopedRatingsPoint = {
  date: string;
  /** The storefront's average; null in the global scope, where no worldwide average is recorded, and on a day it did not fetch. */
  average: number | null;
  count: number;
};

/**
 * The storefront series as the card draws it. Points without a count are skipped,
 * because a gap in the collector is not a day with zero ratings.
 */
export function toStorefrontSeries(items: readonly RatingsPoint[]): ScopedRatingsPoint[] {
  const points: ScopedRatingsPoint[] = [];
  for (const it of items) {
    if (typeof it.count !== 'number') continue;
    points.push({ date: it.date, average: it.average, count: it.count });
  }
  return points;
}

/** The worldwide series as the card draws it: the count, never an average. */
export function toGlobalSeries(items: readonly WorldwidePoint[]): ScopedRatingsPoint[] {
  return items.map((p) => ({ date: p.date, average: null, count: p.count }));
}
